"use client";

import { FC } from "react";
import HeaderBackground from "@/components/ui/header-background";
import TwoColumnsBlock from "@/components/ui/two-columns-block";
import Breadcrumbs from "@/components/entities/breadcrumbs";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import { useTranslations } from "next-intl";
import { useDesignersData } from "@/views/design/hooks/useDesignersData";

const DesignersHeader: FC = () => {
  const t = useTranslations();
  const { designersPage, loadingPage } = useDesignersData();
  if (loadingPage || !designersPage) return null;

  const headerConfig = {
    title: designersPage.address_block.title,
    subtitle: designersPage.address_block.description,
  };

  const breadcrumbs = [{ title: t("home"), url: "/" }];

  return (
    <>
      <HeaderBackground type="video" src={designersPage.address_block.video} />
      <Container>
        <div className={S.headerContent}>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <h1 className={S.title}>Design</h1>
          <TwoColumnsBlock {...headerConfig} />
        </div>
      </Container>
    </>
  );
};

export default DesignersHeader;
